













































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RowHeader extends Vue {
  private varietyGrowthSort (name: string) {
    this.$emit('variety-growth-sort', name)
  }
}
